export default "__VITE_ASSET__BYmoTmHk__"